import React from 'react';

const baseCard = 'rounded-xl border border-slate-200 bg-white shadow-none overflow-hidden';
const baseSection = 'px-6 py-4';
const headerBase = `${baseSection} border-b border-slate-200 text-sm font-semibold text-slate-900 flex items-center justify-between gap-3`;
const bodyBase = `${baseSection} text-slate-800`;
const footerBase = `${baseSection} border-t border-slate-200 bg-slate-50 text-sm text-slate-700`;

const Card = ({
  header,
  footer,
  children,
  className,
  headerClassName,
  bodyClassName,
  footerClassName,
  ...props
}) => {
  const cardClasses = [baseCard, className || ''].filter(Boolean).join(' ');
  const headerClasses = [headerBase, headerClassName || ''].filter(Boolean).join(' ');
  const bodyClasses = [bodyBase, bodyClassName || ''].filter(Boolean).join(' ');
  const footerClasses = [footerBase, footerClassName || ''].filter(Boolean).join(' ');

  return (
    <div className={cardClasses} {...props}>
      {header && <div className={headerClasses}>{header}</div>}
      <div className={bodyClasses}>{children}</div>
      {footer && <div className={footerClasses}>{footer}</div>}
    </div>
  );
};

export default Card;

